var map = {
	"./1AGP.png": 78002,
	"./2AGP.png": 5181,
	"./3AGP.png": 55258,
	"components/Catalog/AGP/img/glass/pr/prPlusBlack/1AGP.png": 78002,
	"components/Catalog/AGP/img/glass/pr/prPlusBlack/2AGP.png": 5181,
	"components/Catalog/AGP/img/glass/pr/prPlusBlack/3AGP.png": 55258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40533;